import { s as svgImagesLoaded } from './svg-images-loaded-7454cac3.js';
import { i as insertedMarkupFixes } from './inserted-markup-fixes-26b497bf.js';
import CartContent from './cart-content.js';
import { E as EVENTS } from './events-58bc9098.js';
import CartItem from './cart-item.js'; // adjust the path if needed

const activateTemplate = (key, options = {}) => {
  const templateElement = document.querySelector(`template[data-template-key='${key}']`);
  if (!templateElement) {
    if (options.resolveOnMissing) {
      console.warn("Template not found, resolving because of 'resolveOnMissing' option");
      return Promise.resolve({ wasInjected: false });
    }
    return Promise.reject(new Error("Template not found"));
  }

  if (templateElement.hasAttribute("data-has-been-activated")) {
    return Promise.resolve({ wasInjected: false });
  }

  return new Promise((resolve) => {
    const templateClone = svgImagesLoaded(templateElement.content.cloneNode(true));
    templateElement.after(templateClone);
    insertedMarkupFixes(templateClone);
    templateElement.setAttribute("data-has-been-activated", "true");
    resolve({ wasInjected: true });
  });
};

class CartDrawer extends CartContent {
  constructor() {
    super();
    this.classes = {
      ...this.classes,
      freeShippingBarInitialState: "free-shipping-bar--force-progress-to-0",
    };
    this.selectors.templateTag = "template[data-template-key='cart-drawer']";
    this.selectors.addToCartBtn = ".devAddToCartBtn"; // your custom button
  }

  connectedCallback() {
    super.connectedCallback();

    this.dialog = this.closest("dialog");
    this.eventOptions = this.controller.signal;

    setTimeout(() => {
      if (!this.hasDoneInitialRefetch && !this.dialog.open) {
        super.refetchContents();


        

      }
    }, 3000);

    window.addEventListener(EVENTS.CART_DRAWER_OPENING, () => {
      activateTemplate("cart-drawer", { resolveOnMissing: true }).then((data) => {
        if (data.wasInjected) {
          this.setScrollableViewport();
          this.#bindElementEvents();
          this.#bindAddToCartButtons();
        }

        // Automatically remove invalid gifts on drawer open
        this.autoRemoveInvalidGifts();

        const freeShippingBar = this.querySelector(".free-shipping-bar");
        if (freeShippingBar) {
          freeShippingBar.classList.add(this.classes.freeShippingBarInitialState);
          setTimeout(() => {
            freeShippingBar.classList.remove(this.classes.freeShippingBarInitialState);
          }, 600);
        }

       
      });
    }, this.eventOptions);

    document.addEventListener(EVENTS.CART_ITEM_ADDED, () => {
      this.scrollableViewport.scrollTo({ top: 0, behavior: this.dialog.open ? "smooth" : "instant" });
  //      setTimeout(() => {
  //           fetch('/cart.js')
  // .then(res => res.json())
  // .then(cart => {
  //   var items = cart.items;
   
  //   items.forEach(function(item) {
  //     console.log(item)
  //     console.log("done doneo");
  //     var properties = item.properties;

  //     for (var key in properties) {
  //       if (properties[key] === "Free Variety Case") {
  //         var itemid = item.id;
  //         var elemitem = document.querySelector(`[data-cart-item-id="${item.id}"]`);
  //         console.log(elemitem);
  //         elemitem.classList.add('hidden');
  //       }
  //       if(properties[key] === "Free Merch"){
  //         var itemid = item.id;
  //         var elemitem = document.querySelector(`[data-cart-item-id="${item.id}"]`);
  //         console.log(elemitem);
  //         console.log(item.key)
  //         elemitem.classList.add('hidden');
  //       }
  //     }
  //   });
  // });
  //          }, 1000);


     
    });
  }
  


async autoRemoveInvalidGifts() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    console.log("Cart:", cart);

    // Get all product IDs from cart
    const cartProductIds = cart.items.map(item => item.product_id);

    // Loop over all free gift blocks on the page
    document.querySelectorAll(".devFreeEnergyProduct").forEach(giftBlock => {
      const attributeMain = giftBlock.getAttribute("data-product-id");

      // Convert attribute to number to match cartProductIds
      const productId = Number(attributeMain);

      const variantInCart = cartProductIds.includes(productId);

      // Hide or show based on whether product ID is in cart
      if (variantInCart) {
        giftBlock.style.display = "none";
        console.log(`Hiding gift block for product ID ${productId}`);
      } else {
        giftBlock.style.display = ""; // Reset to default
        console.log(`Showing gift block for product ID ${productId}`);
      }
    });
  } catch (error) {
    console.error("Error in autoRemoveInvalidGifts:", error);
  }
}






// async autoRemoveInvalidGifts() {
//   const THRESHOLD_1 = 10000; // 100 in cents
//   const THRESHOLD_2 = 15000; // 150 in cents
  
//    const btn_removal_1 = document.querySelector('.devHideboth');
//   // const btn_removal_1 = document.querySelector('.devBtn_1');
// const VARIANT_ID_1 = btn_removal_1 ? Number(btn_removal_1.dataset.variantsId) : null;
// console.log('Variant ID 1:', VARIANT_ID_1);

// // const btn_removal_2 = document.querySelector('.devBtn_2');
// const VARIANT_ID_2 = btn_removal_1 ? Number(btn_removal_1.dataset.variantId) : null;
// console.log('Variant ID 2:', VARIANT_ID_2);
//   // const VARIANT_ID_1 = 41583554134075; 
//   // const VARIANT_ID_2 = 41906431557691; 

//   try {
//     const response = await fetch("/cart.js");
//     const cart = await response.json();
//     const cartTotal = cart.total_price;
//     const itemsToRemove = [];

//     // Remove VARIANT_ID_1 if cart total < 100
//     if (cartTotal <= THRESHOLD_1) {
//       cart.items.forEach(item => {
//         console.log('id', item.variant_id);
//         const item_id = item.variant_id;
//         if (item_id === VARIANT_ID_1) {
//           console.log("matching")
//           itemsToRemove.push(item.key);
//         }
//       });
//     }

//     // Remove VARIANT_ID_2 if cart total < 150
//     if (cartTotal <= THRESHOLD_2) {
//       cart.items.forEach(item => {
//          const item_id_2 = item.variant_id;
//         if (item_id_2 === VARIANT_ID_2) {
//           console.log("matching")
//           itemsToRemove.push(item.key);
//         }
//       });
//     }

//     // Remove the items
//     for (const key of itemsToRemove) {
//       await fetch("/cart/change.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json"
//         },
//         body: JSON.stringify({ id: key, quantity: 0 })
//       });
//     }

//     // Refresh the drawer if needed
//     if (itemsToRemove.length > 0) {
//       this.refetchContents();
//     }
//   } catch (error) {
//     console.error("Error in autoRemoveInvalidGifts:", error);
//   }
// }



 
#bindAddToCartButtons() {
  this.querySelectorAll(this.selectors.addToCartBtn).forEach((button) => {
    if (button.dataset.bound === "1") return;
    button.dataset.bound = "1";

    button.addEventListener("click", async (event) => {
      event.preventDefault();

      const productWrapper = button.closest(".devFreeEnergyProduct");

      // Try to get selected variant from dropdown
      let variantId = null;
      const variantSelect = productWrapper.querySelector(".devVariantSelect");
      if (variantSelect) {
        variantId = variantSelect.value;
      }

      // Fallback to data attribute
      if (!variantId) {
        variantId = button.dataset.variantId;
      }

      if (!variantId) {
        console.error("No variant ID found.");
        return;
      }

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: variantId, quantity: 1 , properties: { "gift": "true" }}),
        });

        if (!res.ok) {
          throw new Error(`Server responded with status ${res.status}`);
        }

        // Show temporary feedback message
        const feedback =
          productWrapper.querySelector(".devAddToCartFeedback") ||
          button.parentElement.querySelector(".devAddToCartFeedback");

        if (feedback) {
          feedback.style.display = "block";
          setTimeout(() => {
            feedback.style.display = "none";
          }, 3000);
        }

        // Hide gift block if applicable
        if (productWrapper) {
          productWrapper.style.display = "none";
        }

        // Refresh cart drawer and open modal
        const drawer = document.querySelector("cart-drawer");
        if (drawer && typeof drawer.refetchContents === "function") {
          await drawer.refetchContents();
          
  //          setTimeout(() => {
  //           fetch('/cart.js')
  // .then(res => res.json())
  // .then(cart => {
  //   var items = cart.items;

  //   items.forEach(function(item) {
  //     console.log("done doneo");
  //     var properties = item.properties;

  //     for (var key in properties) {
  //       if (properties[key] === "Free Variety Case") {
  //         var itemid = item.id;
  //         var elemitem = document.querySelector(`[data-cart-item-id="${item.id}"]`);
  //         console.log(elemitem);
  //         elemitem.classList.add('hidden');
  //       }
  //       if(properties[key] === "Free Merch"){
  //         var itemid = item.id;
  //         var elemitem = document.querySelector(`[data-cart-item-id="${item.id}"]`);
  //         console.log(elemitem);
  //         elemitem.classList.add('hidden');
  //       }
  //     }
  //   });
  // });
  //          }, 1000);



          if (drawer.dialog && typeof drawer.dialog.showModal === "function") {
            drawer.dialog.showModal();
          }
        }

      } catch (error) {
        console.error("Add-to-Cart failed:", error);
        alert("Oops! Something went wrong while adding the item to your cart. Please try again.");
      }
    });
  });
}









  getHTMLFromSectionResponseText(responseText) {
    const range = document.createRange();
    const fragment = range.createContextualFragment(responseText);
    const content = fragment.querySelector(this.selectors.templateTag)?.innerHTML;
    return content ? range.createContextualFragment(content) : document.createDocumentFragment();
  }

  swapFullContents(newHTML) {
    this.replaceChildren(...newHTML.children);
  }

  determineRefreshMode(newHTML) {
    const oldItems = this.querySelector(this.selectors.cartItems);
    const newItems = newHTML.querySelector(this.selectors.cartItems);
    return (!this.dialog.open || !!oldItems !== !!newItems) ? this.REFRESH_MODES.FULL : this.REFRESH_MODES.PORTIONS;
  }

  contentsRefetched() {
    this.setScrollableViewport();
    this.#bindElementEvents();
    this.#bindAddToCartButtons();
    // Automatically remove invalid gifts after content refetch
    this.autoRemoveInvalidGifts();
  }

  #bindElementEvents() {
    this.addEventListener(EVENTS.CART_NOTE_OPENED, () => {
      this.scrollableViewport.scrollTop = this.scrollableViewport.scrollHeight;
    }, { signal: this.controller.signal });

    const keepButton = this.querySelector("[js-keep-shopping-button]");
    keepButton?.addEventListener("click", () => {
      window.dispatchEvent(new Event(EVENTS.CART_DRAWER_CLOSE));
    }, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}
